
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kishalaya",
      function () {
        return require("private-next-pages/kishalaya.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kishalaya"])
      });
    }
  